const setCurrentUserData = (state, payload) => {
  state.currentUser = payload
}

const setUserData = (state, payload) => {
  state.userData = payload
}

const setUserNotificationSettings = (state, payload) => {
  state.userNotificationSettings = { ...state.userNotificationSettings, ...payload }
  state.userNotificationSettingsLoading = false
}

const updateTotalUsers = (state, payload) => {
  state.totalUsers = payload
}

const updateUsersListTotal = (state, payload) => {
  state.total = payload
}

const resetList = (state) => {
  state.listData = null
}

const updateUserPropertyTotal = (state, payload) => {
  state.userPropertyTotal = payload
}

const updateCurrentOrgUser = (state, payload) => {
  state.currentOrgUser = payload
}

const updateUserPropertyPermissionsTotal = (state, payload) => {
  state.userPropertyPermissionsTotal = payload
}

const updateOrgSubStatus = (state, { orgId, subStatus }) => {
  state.currentUser.orgs = state.currentUser.orgs.map((org) => {
    if (org.id === orgId) {
      org.subStatus = subStatus
    }

    return org
  })
}

const setUserTimezone = (state, payload) => {
  state.userTimezone = payload
}

export default {
  setCurrentUserData,
  setUserData,
  setUserNotificationSettings,
  updateTotalUsers,
  resetList,
  updateUserPropertyPermissionsTotal,
  updateUserPropertyTotal,
  updateCurrentOrgUser,
  updateUsersListTotal,
  updateOrgSubStatus,
  setUserTimezone,
}
